import { QueryResult } from '@apollo/client';
import { createContext } from 'react';
import { GetSearchCar, GetSearchCarVariables } from '../graphql/queries/__generated__/GetSearchCar';

type SearchCarContextType = {
  searchCar: string | null;
  loading: boolean;
  error: any;
  loadSearchCar?: (callback?: (result?: QueryResult<GetSearchCar, GetSearchCarVariables>) => void) => () => void;
};

const SearchCarContext = createContext<SearchCarContextType>({
  searchCar: null,
  loading: true,
  error: null,
});

export default SearchCarContext;
